export const CHANGE_LOGO_COLOR = "CHANGE_LOGO_COLOR"